import React, { useState, useEffect } from 'react';
import AdminDashboard from './AdminDashboard';
import Swal from 'sweetalert2';
import '../../assets/css/admin/allcourses.css';

const DeleteTuitions = () => {
    const [tuitions, setTuitions] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');

    useEffect(() => {
        fetchDeletedTuitions();
    }, []);

    const fetchDeletedTuitions = async () => {
        try {
            const response = await fetch('https://api.myskills.lk/tuition/deleted');
            const data = await response.json();
            setTuitions(data);
        } catch (error) {
            console.error('Error fetching deleted tuitions:', error);
        }
    };

    const handleRestore = async (tuitionId) => {
        Swal.fire({
            title: "Are you sure?",
            text: "Do you want to restore this tuition?",
            icon: "question",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, restore it!"
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const response = await fetch(`https://api.myskills.lk/tuition/restore/${tuitionId}`, {
                        method: 'POST'
                    });
                    if (response.ok) {
                        // Update local state after successful restoration
                        const updatedTuitions = tuitions.filter(tuition => tuition.id !== tuitionId);
                        setTuitions(updatedTuitions);
                        
                        // Show success message
                        Swal.fire({
                            title: "Restored!",
                            text: "The tuition has been restored.",
                            icon: "success"
                        });
                    } else {
                        console.error('Failed to restore tuition');
                        Swal.fire({
                            title: "Error!",
                            text: "Failed to restore the tuition.",
                            icon: "error"
                        });
                    }
                } catch (error) {
                    console.error('Error restoring tuition:', error);
                    Swal.fire({
                        title: "Error!",
                        text: "Failed to restore the tuition.",
                        icon: "error"
                    });
                }
            }
        });
    };

    const handlePermanentDelete = async (tuitionId) => {
        Swal.fire({
            title: "Are you sure?",
            text: "Do you want to permanently delete this tuition? This action cannot be undone!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, delete it permanently!"
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const response = await fetch(`https://api.myskills.lk/tuition/delete/permanent/${tuitionId}`, {
                        method: 'DELETE'
                    });
                    if (response.ok) {
                        // Update local state after successful deletion
                        const updatedTuitions = tuitions.filter(tuition => tuition.id !== tuitionId);
                        setTuitions(updatedTuitions);
                        
                        // Show success message
                        Swal.fire({
                            title: "Deleted!",
                            text: "The tuition has been permanently deleted.",
                            icon: "success"
                        });
                    } else {
                        console.error('Failed to delete tuition permanently');
                        Swal.fire({
                            title: "Error!",
                            text: "Failed to delete the tuition permanently.",
                            icon: "error"
                        });
                    }
                } catch (error) {
                    console.error('Error deleting tuition permanently:', error);
                    Swal.fire({
                        title: "Error!",
                        text: "Failed to delete the tuition permanently.",
                        icon: "error"
                    });
                }
            }
        });
    };

    // Filter tuitions based on search term
    const filteredTuitions = tuitions.filter(tuition => 
        (tuition.className && tuition.className.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (tuition.subject && tuition.subject.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (tuition.teacherName && tuition.teacherName.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (tuition.teacherEmail && tuition.teacherEmail.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (tuition.contact && tuition.contact.toLowerCase().includes(searchTerm.toLowerCase()))
    );

    const handleSearchSubmit = (e) => {
        e.preventDefault(); // Prevent form submission
    };

    return (

        <div>

            <AdminDashboard />

            <div className='AllViews-admin-course'>

                <div className="search-icon-admin admin-course-search">

                    <h1>DELETED TUITIONS</h1>
                    <form onSubmit={handleSearchSubmit}>
                        <input 
                            type="text" 
                            placeholder='Search Item' 
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                        <input type="submit" value="SEARCH" />
                    </form>
                   
                </div>

                <div className="scroller-box">
                    <div className="table-course">
                    <table>
                            <thead>
                                <tr>
                                    <th>Class Name</th>
                                    <th>Subject</th>
                                    <th>Teacher Name</th>
                                    <th>Start Date</th>
                                    <th>Time</th>
                                    <th>Contact</th>
                                    <th>Email</th>
                                    <th>View</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                            {filteredTuitions.map((tuition) => (
                                    <tr key={tuition.id}>
                                        <td>{tuition.className}</td>
                                        <td>{tuition.subject}</td>
                                        <td>{tuition.teacherName}</td>
                                        <td>{new Date(tuition.startDate).toLocaleDateString('en-CA')}</td>
                                        <td>{new Date(`1970-01-01T${tuition.time}Z`).toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true })}</td>
                                        <td>{tuition.contact}</td>
                                        <td>{tuition.teacherEmail}</td>
                                        <td><a href="#!" id='view-website'>WEBSITE</a></td>
                                        <td id='action-buttons'>
                                            <a href="#!" id='restore-details' onClick={() => handleRestore(tuition.id)}>RESTORE</a>
                                            <a href="#!" id='del-details' onClick={() => handlePermanentDelete(tuition.id)}>DELETE</a>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>

                    </div>

                </div>

            </div>



        </div>

    )

}

export default DeleteTuitions